<template>
  <base-input :rules="internalRules" :errors="errors" :class="$attrs.class" :no-error-space="noErrorSpace">
    <div
      :class="[
        'relative border rounded-md focus-within:ring-1 ring-0 flex items-center transition-all ease-in-out duration-100 bg-white z-10 mt-1',
        `focus-within:ring-${focusColor} focus-within:border-${focusColor} border-${borderColor}`,
      ]"
    >
      <label :class="['absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-normal', `text-${labelColor}`]" v-if="label">{{ label }}</label>
      <div :class="`flex items-center text-gray-600 pl-3 -mr-1.5 font-thin sm:text-${size} flex-shrink-0 z-0`" v-if="$slots.prefix">
        <slot name="prefix" />
      </div>
      <input
        v-bind="inputAttrs"
        :type="type"
        :class="['form-input flex-grow block w-full border-0 p-0 text-gray-900 focus:ring-0 font-light px-3 py-2  rounded-md ', `placeholder-${placeholderColor} sm:text-${size}`]"
        :placeholder="placeholder"
        @blur="validate"
        @input="$emit('update:modelValue', $event.target.value)"
        :value="modelValue"
        ref="input"
        :disabled="disabled"
        :maxlength="maxLength"
      />
      <div :class="`text-gray-600 pr-3 -ml-1.5 sm:text-${size}`" v-if="$slots.postfix">
        <slot name="postfix" />
      </div>
    </div>
  </base-input>
</template>

<script>
import validatable from "@/mixins/validatable";
import BaseInput from "@/components/base/BaseInput";

export default {
  inheritAttrs: false,
  mixins: [validatable],
  components: {
    BaseInput,
  },
  props: {
    modelValue: [String, Number],
    label: String,
    placeholder: String,
    size: {
      type: String,
      default: "sm",
    },
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: null,
    },
    noErrorSpace: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
    inputAttrs() {
      const rest = { ...this.$attrs };
      delete rest.class;
      return rest;
    },
  },
  methods: {
    reset() {
      this.isResetting = true;
      this.$emit("update:modelValue", null);
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>
